/** Representa la interacción con LocalStorage */
export default class LanguajeLocalStorage {
  /** Instancia de la clase   */
  private static _instance: LanguajeLocalStorage;

  /** Patron Singleton
   * @returns {instance} _instance LanguajeLocalStorage
   */
  static get instance(): LanguajeLocalStorage {
    if (!this._instance) {
      this._instance = new LanguajeLocalStorage();
    }
    return this._instance;
  }

  /** Key del objeto en el localStorage para columnas seleccionadas */
  private static LANGUAGE_COOKIE_KEY = 'storeLang';

  /** Actualiza registros seleccionados  */
  public setLanguage = (lang: string) => {
    localStorage.setItem(LanguajeLocalStorage.LANGUAGE_COOKIE_KEY, lang);
  }

  /** Obtiene lenguaje  */
  public getLanguage(): string | null {
    return localStorage.getItem(LanguajeLocalStorage.LANGUAGE_COOKIE_KEY);
  }

 
}
